import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    gridArea: 'sidemenu',
    overflow: 'hidden',

    '& .header-bar': {
      minHeight: theme.spacing(8) - 1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      overflow: 'hidden',

      '& .toggle-side-menu': {
        height: '100%',
        padding: `0 ${theme.spacing(2)}px`,
        color: theme.palette.text.hint,

        '&-text': {
          fontWeight: theme.typography.fontWeightMedium,
          color: theme.palette.text.secondary,
        },
        '&-icon': {
          marginLeft: theme.spacing(1),
          color: theme.palette.text.secondary,

          '&.opened': {
            transform: 'rotate(180deg)',
          },
        },
      },
    },

    '& .modules': {
      '&-container': {
        maxHeight: '100%',
        overflow: 'auto',
      },
    },

    '& .new-appointment': {
      '&-container': {
        marginTop: 'auto',
        borderTop: `solid 1px ${theme.palette.divider}`,
      },
      '&-button': {
        color: theme.palette.custom.feedback.positive,
      },
      [theme.breakpoints.up('sm')]: {
        '&-button': {
          minHeight: theme.spacing(6),
        },
      },
    },

    [theme.breakpoints.up('md')]: {
      '&:not(.loading)': {
        borderLeft: `solid 1px ${theme.palette.divider}`,
      },
      backgroundColor: theme.palette.custom.background.area,
      width: '100%',

      '&.open': {
        width: 320,
        maxWidth: `calc(100vw - ${theme.spacing(6)}px)`,
        minWidth: '20vw',

        '& .header-bar': {
          padding: `0 ${theme.spacing(0)}px 0 ${theme.spacing(1) / 2}px`,
        },
      },

      '&.close': {
        width: 'auto',
        height: theme.spacing(8),
        overflow: 'hidden',
        borderBottom: `solid 1px ${theme.palette.divider}`,
      },
    },

    [theme.breakpoints.down('sm')]: {
      '& .header-bar': {
        paddingLeft: theme.spacing(1),
      },
    },
  },
  drawerPaper: {
    maxHeight: '100%',
    overflow: 'hidden',

    [theme.breakpoints.down('sm')]: {
      width: `calc(100vw - ${theme.spacing(6)}px)`,
      maxWidth: '320px',
    },
    [theme.breakpoints.up('md')]: {
      position: 'relative',
      border: 'none',
    },
  },
}));

export default styles;
